import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';
import { z } from 'zod';

import { FeApi, useInjectFeApiContext } from '@/api/fe-api';

import { SiteSchema } from '../entities/site';
import { WorkstreamSchema } from '../entities/workstream';

export namespace DeleteWorkstreamMutation {
  export type Input = { id: string };
  export const OutputSchema = z.object({
    workstream: WorkstreamSchema.pick({ id: true }).extend({
      site: SiteSchema.pick({ id: true }),
    }),
  });
  export type Output = z.infer<typeof OutputSchema>;

  function outputMapper(data: FeApi.DeleteWorkstreamViewOutput): Output {
    return {
      workstream: {
        id: data.uuid,
        site: { id: String(data.site_accure_id) },
      },
    };
  }

  function useMutationFn() {
    const deleteWorkstream = useInjectFeApiContext(
      FeApi.tasksV1WorkstreamsDeleteDestroy,
    );

    return async function mutationFn(input: Input) {
      const deleteResult = await ok(
        deleteWorkstream({
          uuid: input.id,
        }),
      );

      return outputMapper(deleteResult);
    };
  }

  export function useMutation() {
    const queryClient = rq.useQueryClient();
    const mutationFn = useMutationFn();

    return rq.useMutation<Output, unknown, Input>({
      mutationFn,
      async onSuccess() {
        await queryClient.invalidateQueries({
          queryKey: ['project-management'],
        });
      },
    });
  }
}
